import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';

const UserProfilePageCodeSplit = lazyForPaint(() =>
  import(/* webpackChunkName: "chunk-user-profile-page" */ './UserProfilePage').then(
    (module) => module.default
  )
);

export default function UserProfileRouteHandler() {
  return (
    <BaseRouteHandler scrollToTopOnPathChange>
      <LazySuspense fallback={<div />}>
        <UserProfilePageCodeSplit />
      </LazySuspense>
    </BaseRouteHandler>
  );
}
